module.exports = __webpack_public_path__ + "static/am-ende-der-hoffnuglosigkeit-02-640df2deddffff57f509e0e2f84d278d.jpg";